module.exports = __webpack_public_path__ + "static/008.4bad417c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image/008.jpg
// module id = 1225
// module chunks = 35783957827783